
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"42.333","height":"35.62"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{staticClass:"a"},[_c('path',{attrs:{"d":"M18.904 27.399a7.711 7.711 0 01-2.536 5.822 8.9 8.9 0 01-6.37 2.4 9.451 9.451 0 01-7.124-3.015q-2.877-3.012-2.877-8.631 0-11.1 5.686-17.193T18.218.001v6.438a11.948 11.948 0 00-7.261 4.933 14.842 14.842 0 00-3.014 8.356 5.085 5.085 0 012.74-.684 7.874 7.874 0 018.221 8.356zm23.426 0a7.71 7.71 0 01-2.535 5.822 8.9 8.9 0 01-6.37 2.4 9.451 9.451 0 01-7.121-3.016q-2.877-3.012-2.877-8.631 0-11.1 5.686-17.193T41.648 0v6.438a11.948 11.948 0 00-7.261 4.933 14.842 14.842 0 00-3.014 8.356 4.671 4.671 0 012.74-.684 7.872 7.872 0 018.22 8.356z","fill":"#fff"}})])])
          )
        }
      }
    